import React, { Component } from 'react';

class ErrorPage extends Component {
    render() {
        return (
            <div>
                You are not authorized to view this page.
            </div>
        )
    }
}

export default ErrorPage;


// WEBPACK FOOTER //
// ./src/containers/ErrorPage/ErrorPage.js